import { useState } from "react";
import { useMutation } from "@tanstack/react-query";
import { Loader2, ShieldCheck } from "lucide-react";
import { API_BASE } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Input } from "@/components/ui/input";

const TOKEN_KEY = "ai-suite-account-token";

export function QaLogin() {
  const [email, setEmail] = useState("qa@alquim-ia.cloud");
  const [code, setCode] = useState("");

  const mutation = useMutation({
    mutationFn: async () => {
      const res = await fetch(`${API_BASE}/account/qa/login`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email, code }),
      });
      const body = await res.json().catch(() => ({}));
      if (!res.ok) throw new Error(body.error || "No se pudo iniciar sesión QA");
      return body as { sessionToken: string };
    },
    onSuccess: (body) => {
      window.localStorage.setItem(TOKEN_KEY, body.sessionToken);
      window.location.href = `${import.meta.env.BASE_URL.replace(/\/$/, "")}/ai-suite`;
    },
  });

  return (
    <div className="mx-auto flex min-h-[80vh] max-w-xl items-center justify-center">
      <Card className="w-full rounded-[2rem] border-white/10 bg-white/[0.06]">
        <CardHeader>
          <CardTitle className="flex items-center gap-3 text-3xl">
            <ShieldCheck className="h-8 w-8 text-emerald-300" />
            Acceso QA
          </CardTitle>
          <CardDescription>Sesión interna para probar todos los servicios sin pasar por el paywall.</CardDescription>
        </CardHeader>
        <CardContent className="space-y-4">
          <Input value={email} onChange={(event) => setEmail(event.target.value)} placeholder="qa@alquim-ia.cloud" className="border-white/10 bg-black/20" />
          <Input value={code} onChange={(event) => setCode(event.target.value)} placeholder="Código QA" type="password" className="border-white/10 bg-black/20" />
          <Button className="h-12 w-full rounded-2xl bg-emerald-300 font-black text-slate-950 hover:bg-white" disabled={mutation.isPending || !email || !code} onClick={() => mutation.mutate()}>
            {mutation.isPending ? <Loader2 className="mr-2 h-5 w-5 animate-spin" /> : null}
            Entrar sin paywall
          </Button>
          {mutation.error ? <div className="rounded-2xl border border-red-300/20 bg-red-500/10 p-3 text-sm text-red-100">{mutation.error.message}</div> : null}
        </CardContent>
      </Card>
    </div>
  );
}
